import { NgbDate } from "@ng-bootstrap/ng-bootstrap";


export class Registro {

  ruc: string;
  razonSocial: string;
  mail: string;
  IdPlan: string;
  estado:number=1
  fecha:string
  clave:string
  direccion:string
  esContribuyente: number=1;
}
export class Registrocompania {

  compania: Registro;

}
